import { Component, ElementRef, Input, ViewEncapsulation } from '@angular/core';

@Component({
	standalone: false,
	selector: 'visiba-progressbar',
	template: `
		<div class="progressbar__line">
			<div *ngIf="type == 'indeterminate'" class="indeterminate" [ngClass]="childClassList"></div>
			<div *ngIf="type == 'determinate'" class="determinate" [ngClass]="childClassList" [ngStyle]="transform()"></div>
		</div>
	`,
	host: {
		'[attr.type]': 'type',
		class: 'progressbar',
	},
	styleUrls: ['../../Css/Components/visibaProgressBar.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class visibaProgressBar {
	@Input('childClass')
	childClassList: string;

	@Input()
	type: 'determinate' | 'indeterminate' = 'determinate';

	@Input()
	get value(): number {
		return this._value;
	}
	set value(val: number) {
		this._value = Math.max(0, Math.min(100, val)) || 0;
	}
	private _value: number = 0;

	// biome-ignore lint/correctness/noUnusedPrivateClassMembers: suppressed due to migration - should be fixed
	private modifedClassList: string;

	constructor(private _ref: ElementRef) {}

	public transform() {
		const scale = this.value / 100;
		return { transform: `scaleX(${scale})` };
	}

	public show(value: boolean) {
		if (value) {
			this._ref.nativeElement.classList.add('js-disable');
		} else {
			this._ref.nativeElement.classList.remove('js-disable');
		}
	}
}
